import React from 'react'
import { AdvisorDetailProps, NetworkAdvisorProps } from '../../utils/types'
import BaseAdvisorProfile from './BaseAdvisorProfile'

const NetworkAdvisor = ({ advisor, position }: NetworkAdvisorProps) => {
  const details: AdvisorDetailProps[] = [
    advisor.compensation && { title: 'Compensation', value: advisor.compensation },
    advisor.certifications && { title: 'Registrations', value: advisor.certifications }
  ].filter(Boolean) as AdvisorDetailProps[]

  return <BaseAdvisorProfile advisor={advisor} details={details} position={position}/>
}

export default NetworkAdvisor
